import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'sg-mysterycards-dialog',
  templateUrl: './mysterycards-dialog.component.html',
  styleUrls: ['./mysterycards-dialog.component.scss']
})
export class MysterycardsDialogComponent {

  @Output() mysterycardsDialogChange = new EventEmitter();

}
